export const postDSPMessage = () => {
    try {
      if (
        window?.AndroidInterface &&
        typeof window?.AndroidInterface?.postMessage === "function"
      ) {
        window?.AndroidInterface?.postMessage("DSP");
      }
      if (
        window?.webkit?.messageHandlers?.voltMessageHandler &&
        typeof window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage === "function"
      ) {
        window?.webkit?.messageHandlers?.voltMessageHandler?.postMessage("DSP");
      }
      if (
        window?.ReactNativeWebView &&
        typeof window?.ReactNativeWebView.postMessage === "function"
      ) {
        window?.ReactNativeWebView.postMessage("DSP");
      }
      if (window.top && window.top !== window) {
        window.top.postMessage("DSP", "*");
      }
    } catch (e) {
      console.warn("postDSPMessage failed", e);
    }
  };